import { Directive, output } from '@angular/core';

/** Apply to the `.modal-overlay` element so modals don't each re-implement the
 *  `target === currentTarget` dismiss guard. */
@Directive({
  selector: '[overlayDismiss]',
  host: { '(click)': 'onClick($event)' },
})
export class OverlayDismissDirective {
  readonly overlayDismiss = output<void>();

  onClick(event: Event): void {
    if (event.target === event.currentTarget) {
      this.overlayDismiss.emit();
    }
  }
}
